/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';
import { FileText, Folder, UserPen } from 'lucide-react';
import { DashboardSummaryCards } from '../../components/dashboard/DashboardSummaryCards';
import { useNavigate } from 'react-router-dom';
import { FileService } from '../../services/file.service';
import { FolderService } from '../../services/folder.service';
import { FileUploadModal } from '../../components/file/FileUploadModal';
import { EditProfileModal } from '../../components/profile/EditProfileModal';
import { FolderModal } from '../../components/folder/FolderModal';

export const UserDashboard = () => {
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [recentFiles, setRecentFiles] = useState<any[]>([]);
  const [folders, setFolders] = useState<any[]>([]);
  const [stats, setStats] = useState({ files: 0, folders: 0 });
  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const [isFolderModalOpen, setIsFolderModalOpen] = useState(false);

  const navigate = useNavigate();

  const loadFiles = async () => {
    try {
      const res = await FileService.getFiles();
      setRecentFiles(res.data.slice(0, 5));
      setStats((prev) => ({ ...prev, files: res.data.length }));
    } catch (err) {
      console.error('Failed to load recent files:', err);
    }
  };

  useEffect(() => {
    loadFiles();
  }, []);

  return (
    <div>
      <DashboardSummaryCards cards={[{ title: 'Files', value: stats.files, icon: <FileText /> }]} />

      <div className="flex flex-col mt-8 lg:flex-row">
        <div className="w-full space-y-10 lg:w-[77%]">
          <div className="sm:w-[85%]">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-primary">Recent Files</h2>
              <a href="/files" className="text-sm font-medium text-primary hover:underline">
                View All
              </a>
            </div>
            {recentFiles.length > 0 ? (
              <ul className="space-y-3">
                {recentFiles.map((file) => (
                  <li
                    key={file.id}
                    className="p-4 bg-white border rounded-md shadow-sm cursor-pointer hover:bg-gray-100 "
                    onClick={() => {
                      window.open(`/files/${file.id}`, '_blank');
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-primary">
                          {file.editedName || file.fileName}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          Uploaded: {new Date(file.uploadedAt).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-muted-foreground">No recent files to show.</p>
            )}
          </div>
        </div>

        <div className="w-full lg:w-[23%]">
          <h2 className="mt-6 mb-4 text-lg font-semibold lg:mt-0 text-primary">Quick Actions</h2>
          <div className="space-y-4">
            <button
              className="flex items-center w-full gap-3 px-4 py-3 border rounded-lg text-primary hover:bg-muted"
              onClick={() => setIsFileModalOpen(true)}
            >
              <FileText className="w-5 h-5" />
              Upload File
            </button>
            <button
              className="flex items-center w-full gap-3 px-4 py-3 border rounded-lg text-primary hover:bg-muted"
              onClick={() => setIsFolderModalOpen(true)} 
            >
              <Folder className="w-5 h-5" />
              Create Folder
            </button>
            <button
              className="flex items-center w-full gap-3 px-4 py-3 border rounded-lg text-primary hover:bg-muted"
              onClick={() => setIsEditProfileOpen(true)}
            >
              <UserPen className="w-5 h-5" />
              Edit Profile
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}
      <FileUploadModal
        isOpen={isFileModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        onSuccess={loadFiles}
      />

      <EditProfileModal isOpen={isEditProfileOpen} onClose={() => setIsEditProfileOpen(false)} />

      <FolderModal
        isOpen={isFolderModalOpen}
        onClose={() => setIsFolderModalOpen(false)}
        onSuccess={() => {}}
      />
    </div>
  );
};
